import React, { useState } from "react";
import "../styles/mobilequestionpalette.css";

const MobileQuestionPalette = ({
  quesData,
  ansArray,
  visitedArr,
  curQues,
  setQues,
  onSubmitClick
}) => {

  const answered = ansArray.filter(x => x != null).length;

const visited =
    new Set([...visitedArr, curQues]).size;

const notVisited =
    quesData.length - visited;

    const [showQuestions, setShowQuestions] = useState(false);

const notAnswered =
    Math.max(visited - answered, 0);

  return (

    <div className="mqp">

      <h3 className="mqp-title">
        Question Palette
      </h3>

      <div className="mqp-summary">

    <div className="mqp-card answered">

        <div className="mqp-left">
            <span className="mqp-icon">✅</span>
            <span className="mqp-text">Answered</span>
        </div>

        <div className="mqp-count">
            {answered}
        </div>

    </div>

    <div className="mqp-card notanswered">

        <div className="mqp-left">
            <span className="mqp-icon">❌</span>
            <span className="mqp-text">Not Answered</span>
        </div>

        <div className="mqp-count">
            {Math.max(notAnswered,0)}
        </div>

    </div>

    <div className="mqp-card notvisited">

        <div className="mqp-left">
            <span className="mqp-icon">⚪</span>
            <span className="mqp-text">Not Visited</span>
        </div>

        <div className="mqp-count">
            {Math.max(notVisited,0)}
        </div>

    </div>

<div className="mqp-card progress">

    <div className="mqp-left">
        📊 Progress
    </div>

    <div className="mqp-count">
        {Math.round(answered * 100 / quesData.length)}%
    </div>

</div>

</div>

      <button
    className="mqp-toggle"
    onClick={() => setShowQuestions(!showQuestions)}
>

    {showQuestions
        ? "Hide Question Numbers ▲"
        : "Show Question Numbers ▼"}

</button>

{showQuestions && (

<div className="mqp-grid">

    {quesData.map((q,index)=>{

        let cls="normal";

        if(index===curQues)
            cls="current";

        else if(ansArray[index]!=null)
            cls="answered";

        else if(visitedArr[index]!=null)
            cls="visited";

        return(

            <button
                key={index}
                className={`mqp-btn ${cls}`}
                onClick={()=>setQues(index)}
            >
                {index+1}
            </button>

        );

    })}

</div>

)}

 <button

className="mqp-submit"

onClick={onSubmitClick}

>

Submit Test

</button> 

    </div>

  );

};



export default MobileQuestionPalette;